import { render, staticRenderFns } from "./BottomBarDialog.vue?vue&type=template&id=9c5f6afe&scoped=true&"
import script from "./BottomBarDialog.vue?vue&type=script&lang=js&"
export * from "./BottomBarDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5f6afe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
